import React, { useEffect } from "react";
import { getPreSignUrl } from "@eolas-medical/core";
import { documentCache } from "./DocumentCache.class";
import DocumentCacheContext from "./documentCache.context";

const DocumentCacheEvents = {
  update: "update-pdf-cache",
  delete: "delete-pdf-cache",
} as const;

const DocumentCacheProvider: React.FC = ({ children }) => {
  const onDeleteCacheItem = React.useCallback((event: any) => {
    documentCache.deleteEntry(event.detail.key);
  }, []);

  const onUpdateCacheItem = React.useCallback((event: any) => {
    documentCache.setItem(event.detail.key, event.detail.value);
  }, []);

  useEffect(() => {
    window.addEventListener(DocumentCacheEvents.delete, onDeleteCacheItem);
    window.addEventListener(DocumentCacheEvents.update, onUpdateCacheItem);

    return () => {
      window.removeEventListener(DocumentCacheEvents.delete, onDeleteCacheItem);
      window.removeEventListener(DocumentCacheEvents.update, onUpdateCacheItem);
    };
  }, [onDeleteCacheItem, onUpdateCacheItem]);

  const getDocumentUrl = (key?: string): Promise<string> => {
    return new Promise(async (resolve, reject) => {
      if (!key) {
        return reject("Missing file key.");
      }

      // return value from the cache
      const cacheValue = documentCache.getItem(key);

      if (cacheValue) {
        return resolve(cacheValue);
      }

      try {
        const s3Url = await getPreSignUrl(key);
        documentCache.setItem(key, s3Url);

        resolve(s3Url);
      } catch (err: any) {
        reject(err);
      }
    });
  };

  return (
    <DocumentCacheContext.Provider value={{ getDocumentUrl }}>
      {children}
    </DocumentCacheContext.Provider>
  );
};

export default DocumentCacheProvider;
